// extracted by mini-css-extract-plugin
export default {"container":"Statistics_container__BHZpo","content":"Statistics_content__sCnfu","table":"Statistics_table__UydBr","dashboard":"Statistics_dashboard__8HXCd"};